import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { BioAparenciaComponent } from './bio-aparencia.component';

@Injectable({ providedIn: 'root' })
export class AlteracoesPendentesGuard implements CanDeactivate<BioAparenciaComponent> {
  canDeactivate(component: BioAparenciaComponent): boolean {
    if (component.temAlteracoesPendentes) {
      return confirm('Voce tem alteracoes nao salvas. Deseja sair sem salvar?');
    }
    return true;
  }
}
